import { PageNavBarTitle } from "@/components/common/PageNavBarTitle";
import React, { ReactNode, createContext, useContext, useState } from "react";

interface AppBarContentContextType {
  appBarContent: ReactNode;
  setAppBarContent: (content: ReactNode) => void;
}

const AppBarContentContext = createContext<AppBarContentContextType | undefined>(undefined);

export const AppBarContentProvider = ({ children }: { children: ReactNode }) => {
  const [appBarContent, setAppBarContent] = useState<ReactNode>("");

  return <AppBarContentContext.Provider value={{ appBarContent, setAppBarContent }}>{children}</AppBarContentContext.Provider>;
};

export const useAppBarContent = (content?: ReactNode | string) => {
  const context = useContext(AppBarContentContext);
  if (!context) {
    throw new Error("useAppBarContent must be used within an AppBarContentProvider");
  }

  React.useEffect(() => {
    if (content !== undefined) {
      const processedContent = typeof content === "string" ? <PageNavBarTitle title={content} /> : content || "";

      context.setAppBarContent(processedContent);
    }

    return () => {
      context.setAppBarContent("");
    };
  }, [content]);

  return context;
};
